import React from "reactn";
import { StepIndicator } from "../../../components/UI";
import Setup from "./Setup";
import AdditionalDetails from "./AdditionalDetails";
import CreateTicket from "./CreateTicket";
import StepBar from "../../../components/UI/StepBar";
import WaitlistAcceptModal from "../../../components/modals/WaitlistAcceptModal";
import Validators from "../../../validators";
import { canUserCreate } from "../../../utilities/listingCreation";
import axios from "axios";
import { toast } from "react-toastify";

class EventsSetup extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      step: 0, // Section of the form currently active.
      canUserMakeNewEvent: false,
      makeEventReqMessage: "",
      showWaitlistAcceptModal: false,
      waitlistData: {
        totalSpots: 0,
        currentSpots: 0,
        waitlistedSpots: 0,
        applicationRequired: false
      }
    };
    this.titles = ["Set-Up", "Create Ticket", "Additional Settings"];
    this.validate = [
      () => Validators.Partners.Profile.ValidateEventsOne(this.global.event),
      () => Validators.Partners.Profile.ValidateEventsTwo(this.global.event),
      () => Validators.Partners.Profile.ValidateEventsThree(this.global.event)
    ];
    this.steps = [
      { name: "Set-Up", validateFn: this.validate[0] },
      { name: "Create Ticket", validateFn: this.validate[1] },
      { name: "Additional Settings", validateFn: this.validate[2] }
    ];
  }

  async componentDidMount() {
    const canUserMake = await canUserCreate("event");
    const makeEventReqMessage = canUserMake.message;
    this.setState({
      canUserMakeNewEvent: canUserMake.success,
      makeEventReqMessage
    });
    if (this.props.match.params.id) {
      await this.dispatch.getEvent(this.props.match.params.id);
    } else {
      if (!this.props.location.state?.fromAIModal) {
        await this.dispatch.resetEvent();
      }
    }

    this.setGlobal({
      partnerPathway: [
        ...this.global.partnerPathway.slice(0, 1),
        { label: "Events", to: "/events/list" },
        {
          label: this.global.event.event_title || "Events Setup",
          to: this.props.location.pathname.replace(/^\/partners/, "") // remove /partners from pathname
        }
      ]
    });
    console.log("props: ", this.props);
  }

  /**
   * To be run before saving. If any page is not setup correctly, it will unpublish the page.
   */
  ensureValidPublish = () => {
    // If the page is currently published
    if (this.global.event.published) {
      // Check validity of all pages
      for (let i = 0; i < this.steps.length; i++) {
        if (this.checkValid(i)) {
          // If any page is invalid, set publish to false
          this.setGlobal({
            event: {
              ...this.global.event,
              published: false
            }
          });
          break;
        }
      }
    }
  };

  acceptWaitlist = async () => {
    const { totalSpots, currentSpots, waitlistedSpots, pendingSpots } =
      this.state.waitlistData;

    const availableSpots = totalSpots - currentSpots - pendingSpots;

    const amountMoved = Math.min(availableSpots, waitlistedSpots);

    if (amountMoved <= 0) {
      console.log("No spots available or no one on waitlist.");
      return;
    }
    let waitlistedUsers = [];
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API}/partners/events/enrollments/all/${this.global.event.id}`
      );
      if (res.data.success) {
        console.log("response", res.data);
        waitlistedUsers = res.data.data
          .filter(item => item.status_stage === "Waitlisted_Unpaid")
          .sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
        console.log("waitlistedUsers", waitlistedUsers);
      }
    } catch (err) {
      console.error("Error fetching spots:", err);
      return;
    }

    const usersToAccept = waitlistedUsers.slice(0, availableSpots);
    if (usersToAccept.length === 0) {
      console.log("No waitlisted users to accept.");
      return;
    }
    let successCount = 0;

    for (const user of usersToAccept) {
      console.log("user to accept", user);
      try {
        const ep = `${process.env.REACT_APP_API}/partners/events/customers/application_accept/${user.id}`;

        const result = await axios.put(ep, {
          status_stage: "Accepted_Unpaid",
          message: "Automated waitlist acceptance due to increased capacity.",
          childName: user.childName
        });

        if (result.data.success) {
          successCount++;
          console.log("waitlist to accept success");
        }
      } catch (err) {
        console.error(`Failed to process user ${user.id}:`, err);
      }
    }

    if (successCount > 0) {
      toast.success(
        `Successfully accepted ${successCount} users from the waitlist!`
      );
      this.setState({ showWaitlistAcceptModal: false });
    } else {
      toast.error("Failed to process waitlist rollovers.");
    }
  };

  handleSave = async e => {
    console.log("HANDLE SAVE");
    const event = this.global.event;
    console.log("EVENT: ", event);

    let totalSpots = 0;
    let currentSpots = 0;
    let waitlistedSpots = 0;
    let pendingSpots = 0;
    let enabledWaitlist = event.enable_waitlist;
    let applicationRequired = event.application_required;
    let selectedEvent;

    try {
      const ep = await axios.get(
        `${process.env.REACT_APP_API}/partners/events/list_manage`
      );
      if (ep.data.success) {
        console.log("EP DATA: ", ep.data.data);
        selectedEvent = ep.data.data.find(e => e.id === event.id);
        console.log("SELECTED EVENT: ", selectedEvent);
        let tickets = selectedEvent.tickets.map(t => JSON.parse(t));
        console.log("TICKETS: ", tickets);
        let ticketCount = 0;
        for (let ticket of tickets) {
          if (ticket.active !== false) {
            ticketCount += Number(ticket.ticket_quantity);
          }
        }
        console.log("TICKET COUNT: ", ticketCount);
        totalSpots = ticketCount;
        currentSpots = selectedEvent.enrolledNum;
      }

      // Fetch waitlisted spots
      const res = await axios.get(
        `${process.env.REACT_APP_API}/partners/events/enrollments/waitlisted/${event.id}`
      );
      if (res.data.success) {
        waitlistedSpots = res.data.data.count;
      }

      const res2 = await axios.get(
        `${process.env.REACT_APP_API}/partners/events/enrollments/all/${this.global.event.id}`
      );
      if (res.data.success) {
        console.log("response", res2.data);
        pendingSpots = res2.data.data.filter(
          item =>
            item.status_stage === "Direct_Unpaid" ||
            item.status_stage === "Accepted_Unpaid"
        ).length;
      }
    } catch (err) {
      console.error("Error fetching spots:", err);
    }
    pendingSpots = 0; // Temporarily set pending spots to 0

    let availSpots = Number(currentSpots) + Number(pendingSpots);
    const showModal =
      enabledWaitlist === true &&
      applicationRequired === false &&
      totalSpots > availSpots &&
      waitlistedSpots > 0;

    this.setState({
      showWaitlistAcceptModal: showModal,
      waitlistData: {
        totalSpots,
        currentSpots,
        waitlistedSpots,
        pendingSpots,
        applicationRequired
      }
    });
    console.log("showModal: ", showModal);
    console.log("waitlistData: ", this.state.waitlistData);
    return showModal;
  };

  saveProfile = async e => {
    const { step } = this.state;

    this.ensureValidPublish();
    console.log("GLOBAL EVENT IN SETUP:", this.global.event);
    switch (e.target.name) {
      case "next":
        this.setState({ step: step + 1 });
        await this.dispatch.saveEvent();
        break;
      case "back":
        this.setState({ step: step - 1 });
        await this.dispatch.saveEvent();
        break;
      case "save":
        await this.dispatch.saveEvent();
        break;
      default:
        return;
    }
  };

  changePage = async page => {
    this.ensureValidPublish();
    if (!this.checkValid()) {
      // Only allow the user to progress to the earliest invalid page
      for (let i = 0; i < page; i++) {
        if (this.checkValid(i)) {
          return; // Prevent the page from changing
        }
      }
      await this.dispatch.saveEvent();
      this.setState({ step: page });
    } else if (page < this.state.step) {
      // Allow the user to backtrack to previous pages
      await this.dispatch.saveEvent();
      this.setState({ step: page });
    }
  };

  getPage = () => {
    switch (this.state.step) {
      case 0:
        return (
          <Setup
            initialAddChild={
              this.props.location.state
                ? this.props.location.state.addChild
                : this.global.event.addChild
            }
            initialManualInvoices={
              this.props.location.state
                ? this.props.location.state.manualInvoices
                : this.global.event.manual_invoices
            }
            initialApplicationRequired={
              this.props.location.state
                ? this.props.location.state.applicationRequired
                : this.global.event.application_required
            }
            initialTransactionCost={
              this.props.location.state
                ? this.props.location.state.transactionCost
                : this.global.program.transaction_cost
            }
            allowSameEnrollment={
              this.props.location.state
                ? this.props.location.state.allowSameEnrollment
                : this.global.event.allowSameEnrollment
            }
            birthdayEvent={
              this.props.location.state
                ? this.props.location.state.birthdayEvent
                : this.global.event.birthdayEvent
            }
          />
        );
      case 1:
        return (
          <CreateTicket
            match={this.props.match}
            birthdayEvent={
              this.props.location.state
                ? this.props.location.state.birthdayEvent
                : this.global.event.birthdayEvent
            }
          />
        );
      case 2:
        return <AdditionalDetails />;
      default:
        return <Setup />;
    }
  };

  checkValid(step = this.state.step) {
    return this.validate[step] && !this.validate[step]();
  }

  getCompletion() {
    let completed = 0;
    for (let v of this.validate) {
      completed += v();
    }
    return (completed / this.validate.length) * 100;
  }

  render() {
    if (!this.state.canUserMakeNewEvent && !this.props.match.params.id) {
      return (
        <div className="container-fluid">
          {/* Commented out to make space for Top Bar */}
          {/* <div className="cont">
            <h1 className="events-title-header">Events</h1>
          </div> */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
              height: "50vh",
              alignItems: "center"
            }}
          >
            <p>{this.state.makeEventReqMessage}</p>
          </div>
        </div>
      );
    }
    return (
      <>
        {this.state.showWaitlistAcceptModal && (
          <WaitlistAcceptModal
            onSubmit={() => {
              this.acceptWaitlist();
              this.saveProfile({ target: { name: "save" } });
            }}
            onManual={() => this.saveProfile({ target: { name: "save" } })} // New prop for manual
            onClose={_ => this.setState({ showWaitlistAcceptModal: false })}
            totalSpots={this.state.waitlistData.totalSpots} // total program spots
            currentSpots={this.state.waitlistData.currentSpots} // currently enrolled
            waitlistedSpots={this.state.waitlistData.waitlistedSpots} // waitlisted count
            pendingSpots={this.state.waitlistData.pendingSpots}
            applicationRequired={this.state.waitlistData.applicationRequired} // true/false
          />
        )}
        <div className="container-fluid">
          {/* Commented out to make space for Top Bar */}
          {/* <div className="cont">
          <h1 className="events-title-header">Events</h1>
        </div> */}
          <StepBar
            {...{
              steps: this.steps,
              changeFn: this.changePage,
              current: this.state.step
            }}
          />
          <StepIndicator value={this.getCompletion()} />
          {this.getPage()}
          <div className="cont mb-5">
            <div
              className="buttons w-100"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end"
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "80%"
                }}
              >
                <div
                  name="back"
                  disabled={this.state.step === 0}
                  onClick={e => {
                    e.target.name = "back";
                    if (this.state.step === 0) return;
                    this.saveProfile(e);
                  }}
                  style={{
                    transform:
                      window.innerWidth < 768 ? "scale(0.8)" : "scale(1)",
                    display: "inline-block",
                    transformOrigin: "left",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <i
                    name="back"
                    style={{
                      paddingRight: window.innerWidth < 768 ? "20px" : "24px"
                    }}
                    className={`fas fa-chevron-left ${
                      this.state.step === 0
                        ? "listing-step-btn-inactive"
                        : "listing-step-btn-active"
                    }`}
                  ></i>
                </div>
                <div
                  name="next"
                  onClick={e => {
                    e.target.name = "next";
                    if (
                      this.state.step === this.titles.length - 1 ||
                      this.checkValid()
                    )
                      return;
                    this.saveProfile(e);
                  }}
                  style={{
                    transform:
                      window.innerWidth < 768 ? "scale(0.8)" : "scale(1)",
                    display: "inline-block",
                    transformOrigin: "left",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <i
                    name="next"
                    style={{
                      paddingLeft: window.innerWidth < 768 ? "20px" : "24px"
                    }}
                    className={`fas fa-chevron-right ${
                      this.state.step === this.titles.length - 1 ||
                      this.checkValid()
                        ? "listing-step-btn-inactive"
                        : "listing-step-btn-active"
                    }`}
                  ></i>
                </div>
              </div>
              {/* <button
              onClick={this.saveProfile}
              disabled={this.state.step === 0}
              name="back"
              className="nextbtn"
            >
              BACK
            </button> */}
              <div
                style={{
                  width: "15%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end"
                }}
              >
                {this.state.step === this.titles.length - 1 && (
                  <button
                    onClick={_ => {
                      this.setGlobal(
                        {
                          event: {
                            ...this.global.event,
                            published: !this.global.event.published
                          }
                        },
                        _ => this.dispatch.saveEvent()
                      );
                    }}
                    name="save"
                    className={
                      this.checkValid() ? "nextbtnDisabled" : "nextbtn"
                    }
                    disabled={this.checkValid()}
                    style={{
                      transform:
                        window.innerWidth < 768 ? "scale(0.8)" : "scale(1)",
                      display: "inline-block",
                      transformOrigin: "right"
                    }}
                  >
                    {this.global.event.published ? "Unpublish" : "Publish"}
                  </button>
                )}
                <button
                  onClick={async e => {
                    // this.saveProfile({ target: { name: "save" } });
                    const target = e.currentTarget;
                    const showModal = await this.handleSave();

                    if (!showModal) {
                      target.name = "save";
                      this.saveProfile({ target: target });
                    }
                  }}
                  name="save"
                  className="savebtn"
                  disabled={this.checkValid()}
                  style={{
                    background: "#b2b8c7",
                    border: "1px solid #b2b8c7",
                    transform:
                      window.innerWidth < 768 ? "scale(0.8)" : "scale(1)",
                    display: "inline-block",
                    transformOrigin: "right"
                  }}
                >
                  SAVE
                </button>
              </div>

              {/* <button
              onClick={this.saveProfile}
              disabled={
                this.checkValid() || this.state.step === this.titles.length - 1
              }
              name="next"
              className="nextbtn"
            >
              NEXT
            </button> */}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default EventsSetup;
